export default __webpack_public_path__ + "static/media/hht1_ep5_minisitcom_03.8eaaaa32.png";